module.exports = __webpack_public_path__ + "img/shippopchilled_charge_logo.a954c89a.png";